/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 02/02/22
 */

import { FormControl, FormLabel, Stack, StackDirection, Textarea, TextareaProps } from '@chakra-ui/react';
import React from 'react';
import ResizingTextarea from '@/components/ResizingTextarea/ResizingTextarea';

const LabeledTextarea = (
    props: TextareaProps & {
        label: string;
        direction?: StackDirection;
        autoResize?: boolean;
    },
) => {
    const { label, direction = 'column', autoResize = true, ...textareaProps } = props;
    return (
        <FormControl as={Stack} direction={direction} w="full">
            <FormLabel whiteSpace={'nowrap'} m={0}>
                {label}
            </FormLabel>
            {autoResize ? <ResizingTextarea {...textareaProps} /> : <Textarea {...textareaProps} />}
        </FormControl>
    );
};

export default LabeledTextarea;
